import styled from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

// ANIMATIONS
import { pump1Animation, pump2Animation, pump3Animation, pump4Animation } from './animations';

export const Container = styled.div`
  display: flex;
`;

export const LoaderSVG = styled.svg`
  height: 32px;
`;

export const GCircle1 = styled.g`
  transform: translate(12, 6);
  animation: ${pump1Animation} 9000ms linear infinite normal forwards;
`;

export const GCircle2 = styled.g`
  transform: translate(20, 6);
  animation: ${pump2Animation} 9000ms linear infinite normal forwards;
`;
export const GCircle3 = styled.g`
  transform: translate(28, 6);
  animation: ${pump3Animation} 9000ms linear infinite normal forwards;
`;

export const GCircle4 = styled.g`
  transform: translate(36, 6);
  animation: ${pump4Animation} 9000ms linear infinite normal forwards;
`;

export const Circle = styled.circle<{ isBlue?: boolean }>`
  transform: translate(0, 0);
  fill: ${({ isBlue }) => (!!isBlue ? theme.colors.primary.bariBlue : theme.colors.primary.white)};
`;
